import React from "react";
import { Box, CircularProgress, Fade } from "@mui/material";

export default () => (
  <Box my={16} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <Fade timeout={2000} in={true}>
      <CircularProgress />
    </Fade>
  </Box>
)
